<template>
    <tr>
        <td style="text-align:center">            
            <v-select
                v-model="itemModel.subject_id"                
                :items="subjects"
                item-value="id"
                outlined
                dense
                hide-details
                @change="updateRecord"
                :disabled="!admin"
                class="table2-select" 
            >
                <template 
                    v-slot:selection="{item}"                                       
                >
                   <span style="font-size:0.8rem; width:40px; text-align:center">{{ item.id }}</span>
                </template>

                <template
                    v-slot:item="data"
                > 
                    {{ data.item.id}} {{ data.item.title }}
                </template>
            </v-select>
        </td>

        <td>{{ itemModel.abbr}}</td>

        <td 
            style="text-align:center"
             v-if="(item.term == 2 && formLevel > 4) || item.term != 2"           
        >
            <v-text-field
                v-model="itemModel.course_mark"
                hide-details                
                type="number"
                outlined
                style="font-size:0.8rem"
                @blur="updateRecord"
                :disabled="!admin" 
                class="table2-select"
            ></v-text-field>
        </td> 

        <td 
            style="text-align:center"
             v-if="(item.term == 2 && formLevel > 4) || item.term != 2"           
        >
            <v-text-field
                v-model="itemModel.exam_mark"
                hide-details                
                type="number"
                outlined
                style="font-size:0.8rem"
                @blur="updateRecord"
                :disabled="!admin" 
                class="table2-select"
            ></v-text-field>
        </td> 
        
        <td 
            style="text-align:center"
             v-if="item.term == 2 && formLevel != 5 && formLevel != 6"           
        >
            <v-text-field
                v-model="itemModel.test_1"
                hide-details                
                type="number"
                outlined
                style="font-size:0.8rem"
                @blur="updateRecord"
                :disabled="!admin" 
                class="table2-select"
            ></v-text-field>
        </td> 

        <td 
            style="text-align:center"
            v-if="item.term == 2 && formLevel != 5 && formLevel != 6" 
        >
            <v-text-field
                v-model="itemModel.test_2"
                hide-details                
                type="number"
                outlined
                style="font-size:0.8rem"
                @blur="updateRecord"
                :disabled="!admin" 
                class="table2-select"
            ></v-text-field>
        </td>

        <td
            style="text-align:center"
            v-if="item.term == 2 && formLevel != 5 && formLevel != 6" 
        >
            <v-text-field
                v-model="itemModel.project"
                hide-details                
                type="number"
                outlined
                style="font-size:0.8rem"
                @blur="updateRecord"
                :disabled="!admin" 
                class="table2-select"
            ></v-text-field>
        </td>

        <td>
            <v-menu
                v-model="menu"
                :close-on-content-click="false"
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind="attrs"
                        v-on="on"
                        style="font-size:0.75rem; font-style: italic;"
                    >
                        {{  subjectRemarks }}           
                    </div>
                </template>

                <v-card width="40vw">
                    <v-card-title> {{ itemModel.title }} Subject Remarks</v-card-title>
                    <v-container>
                        <v-row>
                            <v-col cols="6">
                                <v-select
                                    v-model="itemModel.coded_comment"                
                                    :items="codedComments1"
                                    item-value="id"
                                    outlined
                                    dense
                                    hide-details
                                    @change="updateRecord"
                                    :disabled="!admin"
                                    style="width:100%"  
                                >
                                    <template 
                                        v-slot:selection="{item}"                                       
                                    >
                                       <span >{{ item.detail }}</span>
                                    </template>
                    
                                    <template
                                        v-slot:item="data"
                                    > 
                                        {{ data.item.id}} {{ data.item.detail }}
                                    </template>
                                </v-select>                                   
                            </v-col >

                            <v-col cols="6">
                                <v-select
                                    v-model="itemModel.coded_comment_1"                
                                    :items="codedComments1"
                                    item-value="id"
                                    outlined
                                    dense
                                    hide-details
                                    @change="updateRecord"
                                    :disabled="!admin" 
                                    style="width:100%"   
                                >
                                    <template 
                                        v-slot:selection="{item}"                                       
                                    >
                                    <span >{{ item.detail }}</span>
                                    </template>
                        
                                    <template
                                        v-slot:item="data"
                                    > 
                                        {{ data.item.id}} {{ data.item.detail }}
                                    </template>
                                </v-select>                               

                            </v-col>

                            
                        </v-row>
                    </v-container>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            depressed
                            @click="menu = false"
                        >
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-menu> 
        </td>

        <!-- <td>
        </td>  -->
       
       

        
        <td>
            <v-btn 
                icon
                @click="deleteRecord"
                :disabled="!admin" 
            >
                <v-icon
                    small
                >
                    mdi-delete
                </v-icon>
            </v-btn>
        </td>        
    </tr>    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    props: {
        item: Object,
        formLevel: Number,
        paper3: Boolean,              
    },

    watch: {
        item: {
            handler () {
                this.initialize();
            }
        }
    },
    
    mounted: function () {        
        this.initialize();       
    },

    data: () => ({
        subject: null,
        codedComments1: [],
        codedComments2: [],
        display: false,
        itemModel: {},
        menu: false,
    }),

    computed: {
        ...mapGetters({
            subjects: 'admin/getSubjects',
            codedComments: 'termReports/getCodedComments',
            admin: 'auth/getAdmin',            
        }),
        
        subjectRemarks () {
            const comment1 = this.codedComments.find(comment => comment.id === this.itemModel.coded_comment)?.detail ?? null;
            const comment2 = this.codedComments.find(comment => comment.id === this.itemModel.coded_comment_1)?.detail ?? null;
            if(comment1 && comment2) return `${comment1} / ${comment2}`
            if(comment1) return `${comment1}`
            if(comment2) return `${comment2}`
            return null;
        }
      
    },    

    methods: {
        ...mapActions({
            postTable2Record: 'admin/postTable2',
            getTable2Records: 'termReports/getTable2Records',
        }),

        ...mapMutations({
            setTable2Record: 'admin/setSelectedTable2Record',           
            setTable2Records: 'termReports/setEditViewTermReportsTable2Records',
            setStudentSubjects: 'termReports/setEditViewTermReportsStudentSubjects',
            setSnackbar: 'admin/setSnackbar',
            setDialogDelete: 'admin/setDialogDelete',
            setSaveStatus: 'termReports/setEditViewTermReportsSaveStatus',
            setSaving: 'termReports/setEditViewTermReportsSaving',
            setSaveError: 'termReports/setEditViewTermReportsSaveError',
            setSaved: 'termReports/setEditViewTermReportsSaved',
        }),

        initialize () {
            this.codedComments1 = [...this.codedComments];
            this.codedComments2 = [...this.codedComments];
            this.display = false;
            if(this.item.term == 2 && this.formLevel < 5){
                this.display = true;
            }
            this.itemModel = { ...this.item };
        },

        async updateRecord () {
            this.setSaving(true);
            this.setSaveStatus("Updating Record");
            this.setSaved(false);
            this.setSaveError(false);

            let table2Record = Object.assign({}, this.itemModel);
            table2Record.subject_id_old = this.item.subject_id;
            table2Record.subject_id_new = this.itemModel.subject_id;
            this.setTable2Record(table2Record);
            try {
                const { statusText } = await this.postTable2Record();
                console.log(statusText);

                const { data } = await this.getTable2Records();
                this.setTable2Records(data.table2_records);
                this.setStudentSubjects(data.student_subjects);

                this.setSaving(false);
                this.setSaveStatus("Record Updated");
                this.setSaved(true);
                this.setSaveError(false);

                this.setSnackbar({
                    text: `Record Updated`,
                    display: true,
                    color: 'primary',
                }); 

            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.setSnackbar({
                    text: `Error occured`,
                    display: true,
                    color: 'red',
                });
                
                this.setSaving(false);
                this.setSaveStatus("Error Occured!");
                this.setSaved(false);
                this.setSaveError(true);
            }

            // this.overlay(false);
            // this.loading(false);
        },

        deleteRecord () {                      
            this.setDialogDelete({
                display: true,
                text: `Delete ${this.itemModel.title} ?`,
                cancel: true,
                deleteSubject: true,
                deleteStudent: false,
                ok: false
            })            
            this.setTable2Record(this.item);            
        },
        
    }
}
</script>

<style scoped>
    ::v-deep  .v-input.table2-select{
        width: 60px;
    }    

    ::v-deep .table2-select .v-select__slot{
        height: 20px;
    }

    ::v-deep .table2-select .v-input__icon{
        height: 5px;
        min-width: 8px;
        width: 8px;
    }

    ::v-deep  .table2-select.v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections{
        height: 20px;
        padding: 0px;
    }

    ::v-deep .table2-select.v-input input{
        max-height: 20px;
    }

    ::v-deep .table2-select .v-btn--icon.v-size--default{
        height: 20px;
        width: 20px;
    }

    /* Chrome, Safari, Edge, Opera */
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    ::v-deep input[type=number] {
        appearance: textfield;
        -moz-appearance: textfield;
        -webkit-apperance: none;
    }

    
</style>